import dayjs from "dayjs";

export function appendQueryParams(
  url: string,
  params: Record<string, any | any[]>,
): string {
  const queryParams = new URLSearchParams();

  for (const key in params) {
    if (!params.hasOwnProperty(key)) {
      continue;
    }
    if (Array.isArray(params[key])) {
      params[key].forEach((value: any) => queryParams.append(key, value));
    } else if (params[key] !== undefined && params[key] !== null) {
      queryParams.append(key, params[key]);
    }
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryParams.toString()}`;
}

export function parseCamposRegistroPayload(payload: any): any {
  if (typeof payload !== 'object' || payload === null) return payload;

  if (Array.isArray(payload)) {
    return payload.map(parseCamposRegistroPayload);
  }

  // Remove apenas o underline, para evitar processamento de string desnecessário no front
  // já que o dotnet consegue converter automaticamente no backend
  const result: any = {};
  for (const key in payload) {
    if (payload.hasOwnProperty(key)) {
      const newKey = key.replace(/_/g, '');
      const value = payload[key];

      if(dayjs.isDayjs(value))
      {
        result[newKey] = value.format('YYYY-MM-DD');
        continue;
      }

      result[newKey] = value;
    }
  }
  
  return result;
}
